import { stripeConnect } from 'libs/gb-front/payment/data-access-stripe/src/lib/+state/gb-stripe.models'
import { MenuItemEntity } from './menu-items.models'
import { TaxesEntity } from './taxes.models'
import { ImageEntity, ImagesEntity } from 'libs/gb-front/shared/models/shared.models'
import { PasswordComplexityPolicy } from 'libs/shared/models/shared.models'
import { PaymentMethodsEntity } from './payment-methods.models'

export enum AuctionStatusEnum {
  Running = 'running',
  Closing = 'closing',
  Stopped = 'stopped',
  Paused = 'paused',
}

export interface AuctionEntity {
  uuid: string
  owner: string
  charges_enabled: boolean
  client_account: string
  url_name: string
  name: string
  status: AuctionStatusEnum | ''
  currency: string
  start: Date | undefined
  end: Date | undefined
  timezone: string
  target: number
  description?: string
  donation_target: number
  country: string
  banners: ImagesEntity[] | []
  show_banner_text: boolean
  limit_banner_height: boolean
  logo: ImageEntity | undefined
  primary_color: string
  accent_color: string
  background_color: string
  warn_color: string
  success_color: string
  supported_sms_country_codes: string[] | number[]
  banner_background_color: string
  custom_css: string
  show_banner_overlay: boolean
  sms_service: string
  sms_enabled: boolean
  sms_notifications_enabled: boolean
  payment_gateway: PaymentGatewayTypeEnum | ''
  stripe_connect: stripeConnect | null
  stripe_user_id: string
  stripe_publishable_key: string
  capture_phone_numbers: CaptureAuctionFieldEnum | ''
  capture_emails: CaptureAuctionFieldEnum | ''
  capture_table_numbers: CaptureAuctionFieldEnum | ''
  capture_addresses: CaptureAuctionFieldEnum | ''
  capture_terms_and_conditions_agreement: boolean
  capture_company_name: CaptureAuctionFieldEnum | ''
  capture_company_address: CaptureAuctionFieldEnum | ''
  default_tipping_fee_option: string
  terms_and_conditions: string
  invoice_bank_details: string
  invoice_city: string
  invoice_company_name: string
  invoice_country: string
  invoice_email: string
  invoice_footer_message: string
  invoice_more_information: string
  invoice_phone: string
  invoice_postcode: string
  invoice_state: string
  invoice_street_address: string
  invoice_suburb: string
  invoice_website: string
  invoice_image: ImageEntity | undefined
  is_saas: boolean
  is_single_item: boolean
  credit_card_preauthorisation: CreditCardPreAuthEnum
  additional_info_required: boolean
  homepage: HomePageEnum | ''
  homepage_hub: string
  homepage_infobooth: string
  gift_aid_enabled: boolean
  has_raffle: boolean
  allow_phone_registration: boolean
  allow_email_registration: boolean
  tipping_component: TippingComponentEnum
  tipping_fee: number
  tipping_fee_enabled: boolean
  tipping_fee_options: string[] // tipping dropdown percentages
  tipping_slider_amount_options: string[] // tipping slider percentages
  default_tipping_slider_amount_option: string
  scheduled: boolean
  scheduled_end: Date | undefined | null
  scheduled_start_enabled: boolean
  scheduled_start: Date | undefined | null
  enable_scheduled_time_extend: boolean
  scheduled_time_extend: number
  enable_end_auction_notification: boolean
  enable_facebook_login: boolean
  enable_google_login: boolean
  closed_popup_message: string
  closed_banner_message: string
  paused_banner_message: string
  include_ioc_total_raised: boolean
  enable_activity_feed: boolean
  enable_app_checkout_popup: boolean
  trial_locked: boolean
  single_item_uuid: string | null
  item_count: number
  ticket_package_count: number
  first_ticket_package_uuid: string | null
  enable_bid_activity_poppers: boolean
  enable_donation_activity_poppers: boolean
  enable_purchase_activity_poppers: boolean
  enable_raffle_activity_poppers: boolean
  sms_service_number: string
  registration_custom_fields: RegistrationCustomField[]
  application_version: ApplicationVersionEntity | undefined
  enable_item_activity_feed: boolean
  menu_items: MenuItemEntity[]
  taxes: TaxesEntity[]
  payment_methods: PaymentMethodsEntity[]
  categories: SlimCategoryEntity[]
  event_name: string
  event_dates: string[]
  event_location: EventLocationEntity
  unlimited_event_capacity: boolean
  event_capacity: number | null
  event_tickets_remaining: number
  tickets_label: string
  enable_ticketing: boolean
  event_ticket_preview_enabled: boolean
  password_complexity_policy: PasswordComplexityPolicy | null
  commission_enabled: boolean
  payment_donation_component: PaymentDonationComponentEnum | null
  payment_donation_slider_amounts: string[]
  payment_donation_button_amounts: PaymentDonationButtonAmount[]
}

export interface PaymentDonationButtonAmount {
  percentage: string
  minimum_amount: number
}

export interface ApplicationVersionEntity {
  GALABID_APP_DOMAIN: string
}

export interface SlimCategoryEntity {
  label: string
  label_slug: string
  order: number
  uuid: string
}

export interface EventLocationEntity {
  address: string
  name?: string
  latitude?: number
  longitude?: number
}

export interface RegistrationCustomField {
  uuid: string
  auction: string
  field_name: string
  field_type: 'text' | 'checkbox'
  required: boolean
  help_text: string
  order: number
}

export interface ContactOrganizerPayload {
  message: string
  email: string
  grecaptcha_token: string
}

export enum PaymentDonationComponentEnum {
  Slider = 'slider',
  Buttons = 'buttons',
  RoundUp = 'round_up',
}

export enum TippingComponentEnum {
  Dropdown = 'dropdown',
  Slider = 'slider',
}

export enum CreditCardPreAuthEnum {
  Off = 'off',
  Required = 'required',
}

export enum PaymentGatewayTypeEnum {
  Stripe = 'stripe',
  None = 'none',
}

export enum CaptureAuctionFieldEnum {
  Off = 'off',
  Optional = 'optional',
  Required = 'required',
}

export enum HomePageEnum {
  InfoBooth = 'infobooth',
  Auction = 'auction',
  Hub = 'hub',
  EventTicketing = 'event_ticketing',
}

export enum CookieEnum {
  CookiesConsent = 'gb_front_cookies_consent',
}
